/* eslint-disable no-restricted-globals */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';

// components
import Btn from '../../components/Btn';

// actions
import { startOver } from '../../reducers/StartOverBtn/actions';

// helpers
import MapMarkers from '../../lib/MapMarkers';
import AutocompleteUtils from '../../lib/AutocompleteUtils';

const StartOverBtnPropTypes = {
  directionsLoaded: PropTypes.bool.isRequired, // Helps determine when the button should(n't) display
  label: PropTypes.string.isRequired, // Button label from AEM
  superchargers: PropTypes.arrayOf(PropTypes.object).isRequired, // Network of superchargers
  isMobile: PropTypes.bool.isRequired, // True when the app is loaded on a handheld sized device
  showAltMap: PropTypes.bool.isRequired, // True when user has unlocked easter egg
  dispatchStartOver: PropTypes.func.isRequired, // Start with a clean slate
};

const StartOverBtnDefaultProps = {};

class StartOverBtn extends Component {
  constructor(props) {
    super(props);

    this.startOver = this.startOver.bind(this);
  }

  startOver() {
    const {
      superchargers,
      isMobile,
      showAltMap,
      dispatchStartOver,
    } = this.props;

    // reload the page if user has unlocked the easter egg
    if (showAltMap) location.reload();

    dispatchStartOver();

    // refresh superchargers
    MapMarkers.updateChargerIconSize(superchargers);

    // clear autocomplete results
    AutocompleteUtils.clearPredictions();

    // restore the super charger network on desktop
    if (!isMobile) {
      this.plotNetwork();
    }
  }

  plotNetwork() {
    const { superchargers } = this.props;
    const { map } = window;

    // eslint-disable-next-line arrow-parens
    superchargers.map(charger => {
      const coords = {
        id: charger.id,
        lat: charger.geoPoint.lat,
        lng: charger.geoPoint.lon,
      };

      if (!MapMarkers.markers[coords.id].map) {
        MapMarkers.markers[coords.id].setMap(map);
      }

      return null;
    });
  }

  render() {
    const { directionsLoaded, label } = this.props;

    return (
      <Btn
        styles={classNames('start-over-btn', {
          hidden: directionsLoaded,
        })}
        handleClick={this.startOver}
      >
        {label}
        <i className="tsla-icon_map--clear" />
      </Btn>
    );
  }
}

StartOverBtn.propTypes = StartOverBtnPropTypes;

StartOverBtn.defaultProps = StartOverBtnDefaultProps;

const mapStateToProps = state => ({
  directionsLoaded: state.Directions.directionsLoaded,
  label: state.StartOverBtn.label,
  superchargers: state.Superchargers.superchargers,
  zoom: state.GoogleMap.zoom,
  chargerBody: state.Superchargers.body,
  showAltMap: state.Directions.showAltMap,
  isMobile: state.App.isMobile,
});

const mapDispatchToProps = dispatch => ({
  dispatchStartOver: () => {
    dispatch(startOver());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(StartOverBtn);
